import loadable from '@loadable/component';
import articlePageQuery from './query.graphql';

const ArticlePage = loadable(() =>
  import(/* webpackChunkName: "article" */ './article')
);

ArticlePage.graphQL = articlePageQuery;

ArticlePage.variables = v => v;

ArticlePage.loadOrder = [{}];

export default ArticlePage;
